import { Box, Typography, useTheme } from '@material-ui/core';
import { TranslatedTextV2 } from 'components/atoms/TranslatedText';
import { IOSSwitch } from 'components/molecules/FormControls/switch';
import _ from 'lodash';
import { useDispatch } from 'react-redux';
import { ITabContentProps, PropertyFilterType } from '../configuration';
import ProductFilterActions from '../store/actions';

const TabLandOptions = (props: ITabContentProps) => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isChecked = (currentKey: string) => {
    var isChecked = false;
    for (let key of Object.keys(props.selections.LandOptions.data))
      if (key !== currentKey)
        isChecked =
          isChecked || _.get(props.selections.LandOptions.data, key, null);
    return isChecked;
  };
  const onValueChange = (key: string, value: boolean | null) => {
    dispatch(
      ProductFilterActions.setFiltersSelectionAction({
        ...props.selections,
        [PropertyFilterType.LandOptions]: {
          ...props.selections[PropertyFilterType.LandOptions],
          // ...(isChecked(key) ? { isChecked: true } : { isChecked: false }),
          isChecked: true,
          data: {
            ...props.selections[PropertyFilterType.LandOptions].data,
            [key]: value,
          },
        },
      })
    );
  };

  return (
    <Box
      style={{
        position: 'relative',
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: '16px',
          lineHeight: '20px',
          marginBottom: '4px',
        }}
      >
        <TranslatedTextV2 translationKey={``} defaultText="Land Options" />
      </Typography>
      <Typography
        style={{
          fontWeight: 400,
          fontSize: '12px',
          lineHeight: '16px',
          color: theme.palette.text.secondary,
          marginBottom: '18px',
        }}
      >
        <TranslatedTextV2
          translationKey={''}
          defaultText={'Select one or more'}
        />
      </Typography>
      <section>
        <label style={{ marginRight: 15 }}>Electricity</label>
        <IOSSwitch
          checked={
            props.selections[PropertyFilterType.LandOptions].data.electricity ??
            false
          }
          onChange={(event) =>
            onValueChange('electricity', event.target.checked)
          }
        />
      </section>
      <section>
        <label style={{ marginRight: 15 }}>Water supply</label>
        <IOSSwitch
          checked={
            props.selections[PropertyFilterType.LandOptions].data
              .water_supply ?? false
          }
          onChange={(event) =>
            onValueChange('water_supply', event.target.checked)
          }
        />
      </section>
      <section>
        <label style={{ marginRight: 15 }}>Road access</label>
        <IOSSwitch
          checked={
            props.selections[PropertyFilterType.LandOptions].data.road_access ??
            false
          }
          onChange={(event) =>
            onValueChange('road_access', event.target.checked)
          }
        />
      </section>
    </Box>
  );
};

export default TabLandOptions;
